import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import StripeSessionData from '@/StripeSessionData';
import SubscriptionData from '@/SubscriptionData';

export class StripeServiceStatic {
    createStripeCheckoutSession(mode: string, priceId: string, offeredFreeTrial: boolean): Promise<AxiosResponse<StripeSessionData>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/upgrade/${mode}/${priceId}/${offeredFreeTrial}`
        return AxiosPostProcessor.postProcess(Axios.get<StripeSessionData>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    getSubBySessionId(sessionId: string): Promise<AxiosResponse<SubscriptionData>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/getsubbysessionid/${sessionId}`
        return AxiosPostProcessor.postProcess(Axios.get<SubscriptionData>(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const StripeService = new StripeServiceStatic();
export default StripeService;
